import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import type { NextPageWithLayout } from 'nextjs/types';

import { base } from 'nextjs/getServerSideProps';
import PageNextJs from 'nextjs/PageNextJs';

import Home from 'ui/pages/Home';
import LayoutHome from 'ui/shared/layout/LayoutHome';

const Page: NextPageWithLayout = () => {
  return (
    <PageNextJs pathname="/">
      <Home/>
    </PageNextJs>
  );
};

Page.getLayout = function getLayout(page: React.ReactElement) {
  return (
    <LayoutHome>
      { page }
    </LayoutHome>
  );
};

export default Page;

// export { base as getServerSideProps } from 'nextjs/getServerSideProps';

export const getServerSideProps = async(context) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale, [ 'common' ])),
      ...(await base(context)),
    },
  };
};
